import { createStore } from 'vuex'

import appStore from './app-store'
import tabsStore from './tabs-store'
import mediaStore from './media-library/medialibrary-store'
import advancedCarousel from './advanced-carousel/advanced-carousel-store'
import onetrust from './onetrust/onetrust-store'
import formStore from './form-store'
import shareConfig from './share-config-store'

export default createStore({
  modules: {
    appStore,
    tabsStore,
    mediaStore,
    advancedCarousel,
    onetrust,
    formStore,
    shareConfig
  }
})
